<template>
    <div>
    <b-card class="admins-list">
      <template slot="header">
        <h3 aria-level="1">Upload Files</h3>
      </template>
      <b-card-body>
        <search-section search-placeholder="Search Uploads..." @search="handleSearch" @limit-change="handleLimitChange"/>
        <v-client-table ref="uploadsTable" v-bind:data="uploadFiles" v-bind:columns="columns" :options="options" id="dataTable" class="uploads-file-list">
            <span slot="community" slot-scope="props" class="display-link"> {{props.row.community && props.row.community.name}} </span>
            <span slot="file name" slot-scope="props"> {{props.row.originalFileName}} </span>
            <span slot="status" slot-scope="props"> {{setStatus(props.row.currentStatus)}} </span>
            <span slot="upload date" slot-scope="props"> {{props.row.when | momentDate}} </span>
            <span slot="process date" slot-scope="props" > {{props.row.fileUploadDate? props.row.fileUploadDate: props.row.completed ? props.row.completed: 'N/A' | momentDate}} </span>
        </v-client-table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import SearchSection from '@/views/engagement/components/searchSection.vue';

export default {
    name: 'Uploads',
    components: {
      SearchSection
    },
    data() {
        return {
            uploadFiles: [],
            columns: ['community', 'originalFileName', 'status', 'upload date', 'process date'],
            token: localStorage.getItem('token'),
            options: {headings: {
              originalFileName: 'File Name'
            },
              sortable: ['community', 'status', 'upload date', 'process date'],
              sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
              pagination: {
                show: false,
                dropdown: false,
                chunk: 5,
                edge: false,
                nav: 'scroll'
              }
            },
            filterable: true,
            perPageDropdown: [],
            userData: {community: [], role: ''}
        }
    },
    created() {
        let authUser = JSON.parse(localStorage.getItem('authUser'));
        const userData = {
          community: authUser.communities,
          role: authUser.role
        }
        if (authUser && authUser.role === 'Admin') {
          this.columns = ['community', 'originalFileName', 'status', 'upload date', 'process date'];
        }
        this.loadData(userData);
    },
    methods: {
      setStatus(status) {
        let currentStatus = '';
        switch (status) {
          case "pending":
            currentStatus = "Queued"
            break;
          case "processing":
            currentStatus = "Processed"
            break;
          case "finished":
            currentStatus = "Completed"
            break;
          case "finish":
            currentStatus = "Completed"
            break;
          default:
            break;
        }
        return currentStatus;
      },
      loadData(params) {
        this.axios.post(`${process.env.VUE_APP_API_BASE_URL}/dashboard/upload-files-data/`, {params: params}, {headers: {'x-access-token': this.token}}).then(async response => {
          // console.log("response.data.uploadFiles : ", response.data)
          if (response.data) {
            this.uploadFiles = response.data;
          }
        }).catch(err => {
          if (err.response.status  === 401) {
            localStorage.removeItem('authUser');
            this.$router.push('/login');
          }
        });
        this.$helpers.setTabindexOnTableCells();
      },
      handleSearch(searchText) {
        // Use the search text from the child component to filter your table
        this.$refs.uploadsTable.setFilter(searchText);
      },
      handleLimitChange(newLimit) {
        // Use the new limit value from the child to update your table
        this.$refs.uploadsTable.setLimit(newLimit);
      }
    }
}
</script>
